import { render, staticRenderFns } from "./BusCompanyPage.vue?vue&type=template&id=486cc260&"
import script from "./BusCompanyPage.vue?vue&type=script&lang=js&"
export * from "./BusCompanyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports